define('BluePoint.CustomLoader.CustomLoader'
,   [
		'BluePoint.CustomLoader.CustomLoader.View',
		'jQuery'
	]
,   function (
		CustomLoaderView,
		jQuery
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
            var loaderInterval = setInterval(function ()
            {
                var $loader = jQuery('#loadingIndicator');

                if ($loader.length)
                {
                    $loader.attr('alt', '');

                    if ($loader.attr('alt') === '')
                    {
                        clearInterval(loaderInterval);
                    }
                }
            }, 500);

            var faviconInterval = setInterval(function () {
                var $favicon = jQuery('link[rel="shortcut icon"], link[rel="icon"]');

                if ($favicon.length) {
                    $favicon.attr('href', '/site/images/favicon.ico');

                    if ($favicon.attr('href') === '/site/images/favicon.ico') {
                        clearInterval(faviconInterval);
                    }
                }
            }, 500);
		}
	};
});
